import Vue from 'vue'
import apiClient from '@/services/axios'
import store from 'store'

export async function login(idSchool, nip, password) {
  return apiClient
    .post('/auth/login', {
      user: {
        idSchool,
        nip,
        password,
      },
    })
    .then(response => {
      if (response) {
        // const { id, nip, email, currentYear } = response.data
        store.set('userData', JSON.stringify(response.data))
        const { accessToken } = response.data
        if (accessToken) {
          store.set('accessToken', accessToken)
        }
        return response.data
      }
      return false
    })
}

export async function register(email, password, name) {
  return apiClient
    .post('/auth/register', {
      email,
      password,
      name,
    })
    .then(response => {
      if (response) {
        // const { id, nip, email, currentYear } = response.data
        store.set('userData', JSON.stringify(response.data))
        const { accessToken } = response.data
        if (accessToken) {
          store.set('accessToken', accessToken)
        }
        return response.data
      }
      return false
    })
    .catch(err => console.log(err))
}

export async function currentAccount() {
  return apiClient
    .get('/auth/account')
    .then(response => {
      if (response) {
        // const { id, nip, email, currentYear } = response.data
        store.set('userData', JSON.stringify(response.data))
        const { accessToken } = response.data
        if (accessToken) {
          store.set('accessToken', accessToken)
        }
        return response.data
      }
      return false
    })
    .catch(err => {
      console.log(err)
      if (err.response?.status === 401) {
        store.remove('userData')
        store.remove('accessToken')
        Vue.prototype.$notification.error({
          message: 'Acceso denegado',
          description: err.response.data.message,
        })
      }
    })
}

export async function logout() {
  return apiClient
    .get('/auth/logout')
    .then(() => {
      store.remove('userData')
      store.remove('accessToken')
      return true
    })
    .catch(err => console.log(err))
}
